<template>
  <div class="trocar-senha" v-if="estado">
    <div class="close" @click="fecharTroca"></div>
    <div class="conteudo">
      <button class="botao-fechar">
        <img
          src="@/assets/imgs/icone_fechar_roxo_borda.png"
          alt="Fechar"
          class="fechar"
          @click="fecharTroca"
        />
      </button>

      <form class="miolo" @submit="handleSubmit">
        <h4>Para trocar sua senha insira sua senha atual e em seguida a nova senha.</h4>
        <div class="linha">
          <div
            class="input"
            :class="
              errors.has('senha') || (cErrors.inputError && cErrors.inputError.senhaAtual)
                ? 'error'
                : null
            "
          >
            <img class="icone" src="@/assets/imgs/icone_senha.png" />
            <label>Senha Atual</label>
            <input
              v-validate="'required'"
              type="password"
              name="senha"
              autocomplete="new-password"
              v-model="novasenha.senhaAtual"
              placeholder="Digite sua senha atual"
              required
            />
            <p class="text-error" v-if="errors.has('senha')">Necessário informar sua senha atual</p>
          </div>
        </div>
        <div class="linha">
          <div
            class="input"
            :class="
              errors.has('nova_senha') || (cErrors.inputError && cErrors.inputError.novaSenha)
                ? 'error'
                : null
            "
          >
            <img class="icone" src="@/assets/imgs/icone_senha.png" />
            <label>Nova Senha</label>
            <input
              v-validate="'required|min:8'"
              name="nova_senha"
              type="password"
              autocomplete="new-password"
              v-model="novasenha.novaSenha"
              placeholder="Insira sua nova senha"
              ref="nova_senha"
            />
            <p class="text-error" v-if="errors.has('nova_senha')">Informe sua nova senha</p>
          </div>
        </div>
        <div class="linha">
          <div
            class="input"
            :class="errors.has('conf_nova_senha') && fields.conf_nova_senha.dirty ? 'error' : null"
          >
            <img class="icone" src="@/assets/imgs/icone_senha.png" />
            <label>Confirme Nova Senha</label>
            <input
              v-validate="'required|min:8|confirmed:nova_senha'"
              name="conf_nova_senha"
              type="password"
              autocomplete="new-password"
              v-model="novasenha.confirmacao"
              placeholder="Repita a senha nova"
              data-vv-as="nova_senha"
            />
            <p
              class="text-error"
              v-if="errors.has('conf_nova_senha') && fields.conf_nova_senha.dirty"
            >
              Senha não confere
            </p>
          </div>
        </div>
        <div class="linha">
          <div class="input">
            <template v-if="message">
              <p class="success">{{ message }}</p>
            </template>
            <template v-else>
              <button type="submit" class="botao" :disabled="validateButton">
                <template v-if="!loading.changePassword"
                  >REDEFINIR SENHA</template
                >
                <img class="spinner" src="@/assets/imgs/spinner-white.svg" v-else />
              </button>
            </template>
          </div>
        </div>
        <div class="errors" v-if="!!cErrors.status">
          <ul>
            <li v-for="(item, idx) in cErrors.messages" :key="idx">{{ item }}</li>
          </ul>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'TrocarSenha',

  props: {
    estado: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      novasenha: {
        senhaAtual: '',
        novaSenha: '',
        confirmacao: '',
      },
      estadoBotao: false,
    };
  },
  computed: {
    ...mapGetters({
      loading: 'changePassword/loading',
      message: 'changePassword/message',
      cErrors: 'changePassword/errors',
    }),
    validateButton() {
      return (
        !!this.errors.items.length ||
        this.novasenha.senhaAtual === '' ||
        this.novasenha.novaSenha === '' ||
        this.novasenha.confirmacao === ''
      );
    },
  },
  methods: {
    ...mapActions({
      trocarSenha: 'changePassword/changePassword',
      clearAll: 'changePassword/clearAll',
    }),
    async handleSubmit(e) {
      e.preventDefault();
      const response = await this.trocarSenha(this.novasenha);
      if (response) {
        this.novasenha = {
          senhaAtual: '',
          novaSenha: '',
          confirmacao: '',
        };
        this.$validator.reset();
      }
    },
    fecharTroca() {
      this.clearAll();
      this.novasenha = {
        senhaAtual: '',
        novaSenha: '',
        confirmacao: '',
      };
      this.$validator.reset();
      this.$emit('update:fechar', false);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.trocar-senha {
  z-index: 15000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.95);

  & .close {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  & .conteudo {
    position: relative;
    background: white;
    border-radius: 10px;
    width: 660px;
    height: 400px;
    margin-left: -7px;

    & .botao-fechar {
      cursor: pointer;
      position: absolute;
      background: none;
      border: none;
      padding: 0px;
      top: 15px;
      right: 15px;
      z-index: 1;
      transition: all 0.2s ease-in-out;
      outline: none;
      border-radius: 50px;

      &:hover {
        transform: scale(1.2);
      }
    }

    & .miolo {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;

      & .botao {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-family: 'VivoType';
        font-weight: bold;
        background: $cor_roxo;
        position: relative;
        border: none;
        width: 280px;
        height: 46px;
        padding: 0;
        border-radius: 5px;
        color: white;
        outline: none;
        -webkit-box-shadow: 0px 10px 20px 1px rgba(102, 0, 153, 0.45);
        -moz-box-shadow: 0px 10px 20px 1px rgba(102, 0, 153, 0.45);
        box-shadow: 0px 10px 20px 1px rgba(102, 0, 153, 0.45);

        &:hover {
          @extend %gradiente_twilight;
        }

        &:disabled {
          pointer-events: none;
          background: #c7c7c7 !important;
          box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.09) !important;
        }
      }

      & h4 {
        width: 360px;
        text-align: center;
        font-family: 'OpenSans';
        color: $cor_cinza_dark;
        font-weight: bold;
        font-size: 16px;
        margin: 0px;
        margin-bottom: 30px;
      }

      & .linha {
        display: flex;
        width: 280px;
        max-width: 280px;
        margin-bottom: 14px;

        & .input {
          display: flex;
          flex-direction: column;
          position: relative;

          & p.success {
            text-align: center;
            font-size: 10px;
            color: $cor_verde;
            width: 280px;
          }

          & .icone {
            position: absolute;
            top: 0;
            left: 10px;
            max-width: 20px;
            max-height: 20px;
            transform: translate(0, 65%);
          }

          & label {
            color: $cor_cinza_dark;
            font-family: 'OpenSans';
            background: white;
            position: absolute;
            padding: 2px 4px;
            border-radius: 2px;
            font-size: 10px;
            top: 0;
            left: 8px;
            margin-top: -10px;
          }

          & input[type] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }

          & input {
            -webkit-appearance: none;
            font-size: 15px;
            font-weight: bold;
            color: $cor_roxo;
            font-family: 'VivoType';
            width: 202px;
            padding: 12px 38px;
            border: 1px solid $cor_cinza_medium;
            border-radius: 5px;
            outline: none;
          }

          & input:-webkit-autofill,
          input:-webkit-autofill:hover,
          input:-webkit-autofill:focus,
          input:-webkit-autofill:active {
            background-color: white !important;
            color: #660099 !important;
            -webkit-text-fill-color: #660099 !important;
            -webkit-box-shadow: 0 0 0 30px white inset !important;
          }

          & input:-internal-autofill-selected {
            background-color: white !important;
            color: #660099 !important;
            -webkit-box-shadow: 0 0 0 30px white inset !important;
          }

          & ::placeholder {
            color: $cor_cinza_medium;
            font-weight: 200 !important;
          }

          & .spinner {
            width: 40px;
            height: auto;
            opacity: 1;
            fill: #609;
          }
        }
      }

      & .error {
        & input {
          border-color: #f96053 !important;
          color: #f96053 !important;
        }

        & p {
          color: #f96053;
          font-size: 9px;
          margin: 5px;
        }
      }

      .errors {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 280px;
        max-width: 280px;

        & ul {
          list-style: none;
          width: 100%;
          margin: 0;
          padding: 0;

          & li {
            color: #f96053;
            font-size: 9px;
            margin: 5px;
          }
        }
      }
    }
  }
}

@media all and (min-width: 300px) and (max-width: 679px) {
  .popup {
    & .conteudo {
      width: 90vw;
      height: 48vw;
      margin-left: 0px;

      & button {
        top: -23px;
        right: -23px;
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .popup {
    & .conteudo {
      width: 90vw;
      height: 48vw;
      margin-left: 0px;

      & button {
        top: -23px;
        right: -23px;
      }
    }
  }
}
</style>
